/* import __COLOCATED_TEMPLATE__ from './invoice-item.hbs'; */
import { ensureSafeComponent } from '@embroider/util';
import { importSync } from '@embroider/macros';
import Component from '@glimmer/component';

export default class SiteBillingAccountHistoryContainersInvoiceItem extends Component {
  get columns() {
    const INVOICE_ITEMS_COLUMNS = [
      { name: '', componentSuffix: 'timeline-toggle' },
      { name: 'Date', componentSuffix: 'date' },
      { name: 'Details', componentSuffix: 'details' },
      { name: 'Charges', componentSuffix: 'charges' },
      { name: 'Payments', componentSuffix: 'payments' },
      { name: 'Balance', componentSuffix: 'balance' },
    ];

    return INVOICE_ITEMS_COLUMNS.map(column => {
      let module = importSync(`../cells/${column.componentSuffix}`);
      column.columnComponent = ensureSafeComponent(module.default, this);
      return column;
    });
  }
}
